import React, { useEffect, useRef, useState } from "react";
import photographer from "./images/photographer.svg";
import popup from "./images/popup-bg.png";
import "./styles/style.css";

const getCsrfToken = (): string => {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  return meta?.content || "";
};

const ReferralForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await fetch("/submit-refer-photographer", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json",
          "X-CSRF-Token": getCsrfToken()
        },
        body: new URLSearchParams({
          email,
          page_url: window.location.href
        }).toString()
      });
      if (response.ok) onSuccess();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: "15px" }}>
        <label htmlFor="refer-ph-email" style={{ fontWeight: "bold" }}>
          Email<span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="email"
          id="refer-ph-email"
          name="email"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "45px",
            fontSize: "14px",
            boxSizing: "border-box"
          }}
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="geo-btn geo-btn--primary"
        style={{
          width: "150px",
          display: "block",
          margin: "auto",
          padding: "12px",
          backgroundColor: "#259FA5",
          color: "#fff",
          border: "none",
          borderRadius: "45px",
          fontSize: "16px",
          cursor: "pointer"
        }}
      >
        {submitting ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

const InvitePhotographerPopup = ({
  handleCloseClick,
  type
}: {
  handleCloseClick: Function;
  type: string;
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        handleCloseClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleCloseClick]);

  return (
    <div>
      <div
        id="modal-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal--warning geo-modal--show
        geo-modal--scroll"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content geo-privacy-body geo-privacy-modal invite-modal"
          ref={popupRef}
        >
          <div
            className="modal-content"
            style={{
              backgroundImage: `url(${popup})`,
              backgroundPositionY: "bottom",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              minHeight: `448px`
            }}
          >
            <div className="modal-header">
              &nbsp;
              <button className="close" onClick={() => handleCloseClick()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="geo-modal__header geo-modal--warning-bg">
              <img
                className="geo-modal__warn-icon"
                src={photographer}
                alt="photographer-icon"
                style={{ width: 180 }}
              />
              <h4>
                Ready to sell more photos and maximize your photography success?
              </h4>
              <span className="modal-subheader">
                Join GeoSnapShot: the number one platform for sports
                photographers. No sign up fees.
              </span>
            </div>
            <div className="geo-modal__body">
              <br />
              {submitted ? (
                <p style={{ textAlign: "center", fontWeight: "bold" }}>
                  Thank you! Your referral has been submitted.
                </p>
              ) : (
                <ReferralForm onSuccess={() => setSubmitted(true)} />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default InvitePhotographerPopup;
